// Core
import axios from "axios";
import { createBrowserHistory } from "history";

const $http = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_URL,
});

$http.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  return config;
});

$http.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response.status === 401 &&
      error.config &&
      !error.config._isRetry
    ) {
      originalRequest._isRetry = true;
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/refresh`,
          { withCredentials: true }
        );
        localStorage.setItem("token", response.data.accessToken);
        return $http.request(originalRequest);
      } catch (e) {
        console.log("Not authorized");
        localStorage.removeItem("token");
        localStorage.removeItem("channelId");
        createBrowserHistory().push("/login");
        window.location.reload();
      }
    }
    throw error;
  }
);

export default $http;
